import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class OCRService {

  /**
 *
 * @param payload
 * @return {Promise<void>}
 */
  uploadDocumentOCR = async (payload) => {
    const ocr = await Helpers.post({
      url: Constants.OCR,
      data: payload,
    });
    return ocr;
  }
}

export default new OCRService();
